import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const UtahHousingChartYTD = ({ data }) => {
  const chartsData = data;
  const ytdKeys = ["2025 YTD", "2026 YTD"];

  const parsePrice = (value) => {
    if (!value || value === "--") {
      return null;
    }

    const numericValue = Number(String(value).replace(/[$,]/g, ""));
    return Number.isFinite(numericValue) ? numericValue : null;
  };

  const changeValue = chartsData?.["Increase/DecreaseYTD"];
  const hasYtdChange = changeValue && changeValue !== "--";

  if (!chartsData) {
    return "loading...";
  }

  const barData = {
    labels: ytdKeys,
    datasets: [
      {
        label: "Price",
        data: ytdKeys.map((key) => parsePrice(chartsData[key])),
        // backgroundColor: ["rgba(1, 66, 178, 0.8)", "rgba(203, 12, 12, 0.8)"],
        // borderColor: ["rgba(1, 66, 178, 1)", "rgba(203, 12, 12, 1)"],
        borderWidth: 1,
        barThickness: 50,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          color: chartsData.Color, // White color for legend text
        },
      },
      title: {
        display: true,
        text: `Median Sales Price Comparison: ${ytdKeys[0]} vs ${ytdKeys[1]}`,
        color: chartsData.Color,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            if (tooltipItem.raw == null) {
              return "No data";
            }
            return `$${tooltipItem.raw.toLocaleString("en-US")}`;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Year",
          color: chartsData.Color,
        },
        ticks: {
          color: chartsData.Color, // White color for x-axis labels
        },
        grid: {
          color: "rgba(255, 255, 255, 0.2)", // Light white grid lines
        },
      },
      y: {
        title: {
          display: true,
          text: "Price ($)",
          color: chartsData.Color,
        },
        beginAtZero: true,
        ticks: {
          color: chartsData.Color, // White color for x-axis labels
        },
        grid: {
          color: "rgba(255, 255, 255, 0.2)", // Light white grid lines
        },
      },
    },
    animation: {
      duration: 1500,
      easing: "easeInOutBounce",
    },
  };

  const chartStyle = {
    perspective: "1000px",
    transform: "rotateX(-10deg)",
    margin: "20px auto",
    maxWidth: "90%",
    padding: "15px",
  };

  return (
    <div style={chartStyle}>
      <Bar data={barData} options={options} />
      {!hasYtdChange ? (
        <p
          style={{
            textAlign: "center",
            fontSize: "16px",
            marginTop: "10px",
            color: chartsData.Color,
          }}
        >
          {" "}
          <strong>Change:</strong> --
        </p>
      ) : changeValue[0] === "-" ? (
        <p
          style={{
            textAlign: "center",
            fontSize: "16px",
            marginTop: "10px",
            color: "red",
          }}
        >
          {" "}
          <strong>Decrease:</strong> {changeValue}
        </p>
      ) : (
        <p
          style={{
            textAlign: "center",
            fontSize: "16px",
            marginTop: "10px",
            color: "green",
          }}
        >
          {" "}
          <strong>Increase:</strong> {changeValue}
        </p>
      )}
    </div>
  );
};

export default UtahHousingChartYTD;
